// extracted by mini-css-extract-plugin
export default {"wrapper":"outsideMsTeams_wrapper__3jL0e","svg":"outsideMsTeams_svg__ARbTR"};